/*
  Cart count sync.

  The header cart count is rendered server-side by sections/cart-icon-bubble.liquid.
  The theme refreshes it during its own add-to-cart and cart-page flows, but apps
  that write to the cart directly (the slide cart drawer, product options) bypass
  that flow, so the badge goes stale until the next page load.

  This watches for any request to a cart write endpoint, then asks Shopify to
  re-render the cart-icon-bubble section and swaps the result into the header.
  Because Liquid regenerates the section, the count, the cart icon and the
  accessible label all come back correct together.

  Loaded early and without defer so the patches are in place before app scripts
  capture their own reference to window.fetch.
*/
(function () {
  if (window.__cartCountSync) return;
  window.__cartCountSync = true;

  var WRITE_PATHS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  var DEBOUNCE_MS = 150;
  var timer = null;

  function rootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function isCartWrite(url) {
    var value = String(url || '');
    for (var i = 0; i < WRITE_PATHS.length; i++) {
      if (value.indexOf(WRITE_PATHS[i]) > -1) return true;
    }
    return false;
  }

  /*
    The Section Rendering API returns the section wrapped in its .shopify-section
    container, so take the inner HTML of that wrapper. This mirrors what the
    theme's own getSectionInnerHTML does.
  */
  function extractSection(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var wrapper = doc.querySelector('.shopify-section');
    return wrapper ? wrapper.innerHTML : doc.body.innerHTML;
  }

  function refresh() {
    var target = document.getElementById('cart-icon-bubble');
    if (!target) return;

    fetch(rootUrl() + '?sections=cart-icon-bubble', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        if (!data || typeof data['cart-icon-bubble'] !== 'string') return;
        target.innerHTML = extractSection(data['cart-icon-bubble']);
      })
      .catch(function () {
        /* Leave the existing badge in place if the refresh fails. */
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, DEBOUNCE_MS);
  }

  /* fetch: pass the original promise straight through, untouched. */
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = input && input.url ? input.url : input;
      var result = nativeFetch.apply(this, arguments);
      if (isCartWrite(url) && result && typeof result.then === 'function') {
        result.then(schedule, function () {});
      }
      return result;
    };
  }

  /* XMLHttpRequest, in case an app uses it rather than fetch. */
  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__isCartWrite = isCartWrite(url);
    return nativeOpen.apply(this, arguments);
  };

  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__isCartWrite) {
      this.addEventListener('loadend', schedule);
    }
    return nativeSend.apply(this, arguments);
  };

  /* Restored from the back/forward cache, the header can be stale. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });
})();
